<template>
    <div class="container pt-5">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <img src="../../assets/img/logo-login.svg" alt="Login">
                <div class="panel">
                    <h3>Wachtwoord resetten</h3>

                    <p>We zijn er bijna. Kies hieronder een nieuw wachtwoord van minimaal 8 karakters, en klik op "Reset wachtwoord".</p>

                    <form @submit.prevent="resetPassword">
                        <div class="form-group">
                            <label>E-mailadres</label>
                            <input type="email" v-model="formData.email" class="form-control">
                            <form-errors :errors="errors['email']"></form-errors>
                        </div>
                        <div class="form-group">
                            <label>Nieuw wachtwoord</label>
                            <input type="password" v-model="formData.password" class="form-control">
                            <form-errors :errors="errors['password']"></form-errors>
                        </div>
                        <div class="form-group">
                            <label>Bevestig wachtwoord</label>
                            <input
                                type="password"
                                v-model="formData.password_confirmation"
                                class="form-control"
                            >
                        </div>
                        <div class="d-flex">
                            <button class="btn btn--accent ml-auto" :disabled="saving">
                                <i class="fa fa-spin fa-circle-o-notch mr-1" v-if="saving"></i>
                                Reset wachtwoord
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                email: "",
                token: this.$route.params.token,
                password: "",
                password_confirmation: ""
            },
            saving: false,
            errors: {}
        };
    },
    mounted() {},
    methods: {
        resetPassword() {
            if (this.saving) {
                return;
            }

            this.saving = true;

            this.$http
                .post("/auth/reset", this.formData)
                .then(res => {
                    console.log(res);
                    if (res.data.feedback) {
                        this.$root.$emit("notify", {
                            type: res.data.feedback.type,
                            text: res.data.feedback.message
                        });

                        this.saving = false;

                        if (res.data.feedback.type == "success") {
                            this.$router.push({ name: "login" });
                        }
                    }
                })
                .catch(err => {
                    if (err.response.data) {
                        this.$root.$emit("notify", {
                            type: "error",
                            text: err.response.data.message
                        });

                        this.errors = err.response.data.errors;
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
img {
    display: table;
    margin: 0 auto 30px;
}
.form-control {
    background-color: $subtle;
}
</style>
